export default "__VITE_ASSET__BJhFNXKb__"